export interface Item {
  id: number;
  cartikelnummer: string;
  artbez1: string;
  artbez2?: string;
  artbez3?: string;
  idmanartikeldat?: number;
  idarteh?: number;
}
